var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-border-box-7',{staticClass:"statistic",attrs:{"color":['rgba(6,19,34,0.4)', 'rgba(6,19,34,0.5)']}},_vm._l((_vm.items),function(item,index){return _c('dl',{key:index},[_c('dt',[_vm._v(_vm._s(item.title))]),_c('dd',[_c('b',[_vm._v(_vm._s(item.data))]),_vm._v(_vm._s(item.unit))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }